export const PROMOTIONAL_PURPOSE = 10;
export const SUBSCRIPTION_PURPOSE = 102;
